import { combineReducers } from 'redux';

import { ordersReducer } from 'wanderu-orders';

import autoFillFormReducerMap, {
    autoFillFormAction,
} from './actions/autoFillForm';
import checkAccountExistsReducerMap, {
    checkAccountExistsAction,
} from './actions/checkAccountExists';
import createAssociatedAccountReducerMap, {
    createAssociatedAccountAction,
} from './actions/createAssociatedAccount';
import fetchFormAndSummaryReducerMap, {
    fetchFormAndSummaryAction,
} from './actions/fetchFormAndSummary';
import fetchLocationDetailsReducerMap, {
    fetchLocationDetailsAction,
} from './actions/fetchLocationDetails';
import fetchPaymentMethodsReducerMap, {
    fetchPaymentMethodsAction,
} from './actions/fetchPaymentMethods';
import fetchTripBookingInfoReducerMap, {
    fetchTripBookingInfoAction,
} from './actions/fetchTripBookingInfo';
import makeDetailsCallReducerMap, {
    makeDetailsCallAction,
} from './actions/makeDetailsCall';
import makePaymentsCallReducerMap, {
    makePaymentsCallAction,
} from './actions/makePaymentsCall';
import pollBookingStatusReducerMap, {
    pollBookingStatusAction,
} from './actions/pollBookingStatus';
import pollInsuranceStatusReducerMap, {
    pollInsuranceStatusAction,
} from './actions/pollInsuranceStatus';
import submitFormReducerMap, {
    submitFormAction,
} from './actions/submitForm';
import validateFormReducerMap, {
    validateFormAction,
} from './actions/validateForm';
import validateStepReducerMap, {
    validateStepAction,
} from './actions/validateStep';
import bookingReducerMap, {
    actions as bookingActions,
    selectors as bookingSelectors,
} from './appstate';
import namespace from './types';

const reducer = combineReducers({
    ...bookingReducerMap,
    ...autoFillFormReducerMap,
    ...fetchFormAndSummaryReducerMap,
    ...fetchPaymentMethodsReducerMap,
    ...fetchTripBookingInfoReducerMap,
    ...makeDetailsCallReducerMap,
    ...makePaymentsCallReducerMap,
    ...validateFormReducerMap,
    ...validateStepReducerMap,
    ...submitFormReducerMap,
    ...pollBookingStatusReducerMap,
    ...checkAccountExistsReducerMap,
    ...createAssociatedAccountReducerMap,
    ...fetchLocationDetailsReducerMap,
    pollInsuranceStatusReducerMap,
});

export {
    autoFillFormAction,
    bookingActions,
    bookingSelectors,
    checkAccountExistsAction,
    createAssociatedAccountAction,
    fetchFormAndSummaryAction,
    fetchLocationDetailsAction,
    fetchPaymentMethodsAction,
    fetchTripBookingInfoAction,
    makeDetailsCallAction,
    makePaymentsCallAction,
    pollBookingStatusAction,
    pollInsuranceStatusAction,
    submitFormAction,
    validateFormAction,
    validateStepAction,
};

const bookingSlice = {
    [namespace]: reducer,
    orders: ordersReducer,
};

export default bookingSlice;
